import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';

import { Observable } from 'rxjs';

export type ProducerPicker =
    | { status: 'idle' }
    | { status: 'loading' }
    | { status: 'error' }
    | { status: 'ready'; items: any[]; total: number };

@Component({
    selector: 'app-controller-details-producers',
    templateUrl: './controller-details-producers.component.html',
    styleUrls: ['./controller-details-producers.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ControllerDetailsProducersComponent {
    @Input() producerSearchCtrl!: FormControl;
    @Input() filteredProducers$!: Observable<ProducerPicker>;
    @Input() selectedProducers: any[] = [];
    @Input() minSearchLength = 2;
    @Output() producerSelected = new EventEmitter<any>();
    @Output() producerRemoved = new EventEmitter<any>();

    trackById(_: number, producer: any): string {
        return producer.id;
    }
}
